import { Download } from "lucide-react";
import { Reveal } from "../components/shared";
import { SiteLayout, PageHero, CtaBand, Caps, H2 } from "../components/site";
import { EnquiryBtn } from "../components/enquiry";

const STANDARD = [
  ["EAP Counselling (including Crisis Calls)", "$110", "50%"],
  ["Manager Support Hotline", "$110", "50%"],
  ["Manager Check-In", "$110", "50%"],
  ["Manager Referral Session", "$115", "50%"],
  ["Onsite EAP Counselling (EAP@Work)", "$115", "100%"],
  ["Critical Incident Support", "$120", "100%"],
  ["Travel to Company Site (15-min increments)", "$70", "100%"],
  ["Workplace Awareness Session (incl. prep)", "$200", "100%"],
];

const SPECIALIST = [
  ["Individual Supervision / Reflective Practice", "$150", "100%"],
  ["Group Supervision / Reflective Practice", "$180", "100%"],
  ["Executive Coaching", "$180", "100%"],
  ["Psychological Wellbeing Check (Psychologist)", "$120", "100%"],
  ["Psychological Assessment (Psychologist)", "$150", "100%"],
  ["Dietitian Review", "$150", "100%"],
];

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "");

const RateTable = ({ id, title, rows }) => (
  <Reveal>
  <div className="rounded-[28px] bg-white border border-[#3F4A3C]/10 overflow-hidden" data-testid={`eap-table-${id}`}>
    <div className="px-6 sm:px-8 pt-7 pb-5 flex flex-wrap items-baseline gap-x-3">
      <h3 className="font-newsreader text-2xl sm:text-3xl text-[#1F4D3A]">{title}</h3>
      <span className="font-jakarta text-xs uppercase tracking-[0.2em] text-[#8A6A2E]">ex GST</span>
    </div>
    <div className="grid grid-cols-[1fr_auto_auto] gap-x-4 sm:gap-x-10 bg-[#1F4D3A] px-6 sm:px-8 py-3 font-jakarta text-[11px] sm:text-xs uppercase tracking-[0.15em] text-[#F3DCA8]">
      <span>Service</span><span className="text-right">Fee</span><span className="text-right w-20 sm:w-28">DNA / late cancel</span>
    </div>
    <ul className="divide-y divide-[#3F4A3C]/10">
      {rows.map(([name, fee, dna]) => (
        <li key={name} className="grid grid-cols-[1fr_auto_auto] gap-x-4 sm:gap-x-10 items-center px-6 sm:px-8 py-4 font-jakarta text-sm sm:text-[15px] text-[#3F4A3C]" data-testid={`eap-row-${slug(name)}`}>
          <span>{name}</span>
          <span className="text-right font-newsreader text-xl text-[#1F4D3A]">{fee}</span>
          <span className="text-right w-20 sm:w-28 text-[#4A4F45]">{dna}</span>
        </li>
      ))}
    </ul>
    <p className="px-6 sm:px-8 py-5 bg-[#FBF9F4] font-jakarta text-sm text-[#4A4F45]"><span className="font-medium text-[#3F4A3C]">Initial period:</span> 12 months</p>
  </div>
  </Reveal>
);

export default function Eap() {
  return (
    <SiteLayout testid="eap-page">
      <PageHero eyebrow="Employee Assistance Program (EAP)" lines={["Supporting your people.", "Strengthening your workplace."]} sub="Supporting workforce wellbeing, resilience and organisational performance.">
        <EnquiryBtn topic="Professional services" label="Enquire about our EAP" testid="eap-enquire-hero" />
      </PageHero>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-16">
        <Caps>Service schedule & rates</Caps>
        <H2 className="mt-4 !text-3xl sm:!text-4xl">Clear, simple pricing for organisations.</H2>
        <div className="mt-10 grid lg:grid-cols-2 gap-6 items-start">
          <RateTable id="standard" title="Standard EAP services" rows={STANDARD} />
          <RateTable id="specialist" title="Specialist services" rows={SPECIALIST} />
        </div>
        <p className="mt-6 font-jakarta text-xs text-[#4A4F45]" data-testid="eap-footnote">* Rates apply to clinicians meeting organisational service requirements. DNA = did not attend.</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <a href="/downloads/IYD-EAP-Service-Schedule-2026.pdf" download data-testid="eap-download" className="inline-flex items-center gap-2 rounded-full bg-[#1F4D3A] px-6 py-3.5 font-jakarta text-sm text-[#F6F2E9] hover:bg-[#2C6B50] transition-colors"><Download className="w-4 h-4" /> Download EAP schedule (PDF)</a>
          <EnquiryBtn topic="Professional services" label="Talk to us about an EAP for your team" testid="eap-enquire-bottom" />
        </div>
      </section>
      <CtaBand />
    </SiteLayout>
  );
}
